import React from 'react';

// نام و مسیر component از مقدار alias به دست می آید
export const routesArray = [
    {id: 1, alias: 'home', path: '/', access: 'public', icon: 'home', title: 'صفحه نخست', menu: true},
    {id: 2, alias: 'map', path: 'map', access: 'public', icon: 'map', title: 'نقشه', menu: true},
    {id: 3, alias: 'getting-here', path: 'getting-here', access: 'public', icon: 'getting-here', title: 'مسیریابی', menu: true},
    {id: 4, alias: 'services', path: 'services', access: 'public', icon: 'service', title: 'خدمات', menu: true},
    {id: 5, alias: 'more', path: 'more', access: 'public', icon: 'more', title: 'ادامه', menu: true},
    {id: 6, alias: 'more/parking', path: 'more/parking', access: 'public', icon: 'parking', title: 'پارکینگ', menu: true},
    {id: 7, alias: 'more/working-hours', path: 'more/working-hours', access: 'public', icon: 'working-hours', title: 'ساعات کار', menu: true},
    {id: 8, alias: 'more/item', path: 'more/rules', access: 'public', icon: 'rules', title: 'قوانین', menu: true},
    {id: 9, alias: 'more/item', path: 'more/privacy-policy', access: 'public', icon: 'privacy-policy', title: 'سیاست حفظ حریم خصوصی', menu: true},
    {id: 10, alias: 'more/item', path: 'more/terms-and-conditions', access: 'public', icon: 'terms-and-conditions', title: 'شرایط و ضوابط', menu: true},
    {id: 11, alias: 'more/item', path: 'more/anti-fraud-disclaimer', access: 'public', icon: 'anti-fraud-disclaimer', title: 'جلوگیری از تقلب', menu: true},

    {id: 20, alias: 'search', path: 'search', access: 'public', icon: '', title: 'جستجو', menu: false},
    {id: 21, alias: 'offers', path: 'offers', access: 'public', icon: '', title: 'تخفیف ها', menu: false},
    {id: 22, alias: 'services/gift-card', path: 'services/gift-card', access: 'public', icon: '', title: 'کارت هدیه', menu: false},
    {id: 23, alias: 'services/expert-companion', path: 'services/expert-companion', access: 'public', icon: '', title: 'همراه متخصص', menu: false},
    {id: 24, alias: 'events', path: 'events', access: 'public', icon: '', title: 'رویدادها و جایزه ها', menu: false, empty: true},
    {id: 25, alias: 'customer-club', path: 'customer-club', access: 'public', icon: '', title: 'باشگاه مشتریان', menu: false},

    {id: 30, alias: 'search', path: 'shop', access: 'public', icon: '', title: 'خرید کنید', menu: false},
    {id: 31, alias: 'place', path: 'shop/:id', access: 'public', icon: '', title: '', menu: false},
    {id: 32, alias: 'search', path: 'dine', access: 'public', icon: '', title: 'میل کنید', menu: false},
    {id: 34, alias: 'place', path: 'dine/:id', access: 'public', icon: '', title: '', menu: false},
    {id: 35, alias: 'entertain', path: 'entertain', access: 'public', icon: '', title: 'تفریح کنید', menu: false},
    {id: 36, alias: 'place', path: 'entertain/:id', access: 'public', icon: '', title: '', menu: false},
    {id: 37, alias: 'entertain/ticket-order', path: 'entertain/ticket-order', access: 'private', icon: '', title: 'خرید آنلاین بلیط', menu: false},
    {id: 38, alias: 'entertain/ticket-order', path: 'entertain/ticket-order/:id', access: 'private', icon: '', title: '', menu: false},

    {id: 10000, alias: 'account', path: 'account', access: 'private', icon: '', title: 'حساب کاربری', menu: false,
        children: [
            {id: 10001, alias: 'account/customer-club', path: 'customer-club', access: 'private', icon: '', title: 'باشگاه مشتریان', menu: false},
            {id: 10002, alias: 'account/customer-club-invitees', path: 'customer-club-invitees', access: 'private', icon: '', title: 'دعوت شده ها', menu: false},
            {id: 10003, alias: 'account/customer-club-card-number', path: 'customer-club-card-number', access: 'private', icon: '', title: 'شماره کارت بانک', menu: false},
            {id: 10004, alias: 'account/mica-coin', path: 'mica-coin', access: 'private', icon: '', title: 'Mica Coin', menu: false},
            {id: 10005, alias: 'account/mica-coin-lottery', path: 'mica-coin-lottery', access: 'private', icon: '', title: 'قرعه کشی', menu: false},
            {id: 10006, alias: 'account/mica-coin-discount-code', path: 'mica-coin-discount-code', access: 'private', icon: '', title: 'تخفیف', menu: false},
            {id: 10007, alias: 'account/mica-plus', path: 'mica-plus', access: 'private', icon: '', title: 'Mica Credit', menu: false},
            {id: 10008, alias: 'account/mica-ticket', path: 'mica-ticket', access: 'private', icon: '', title: 'Mica Cash', menu: false},
            {id: 10009, alias: 'account/expert-companion', path: 'expert-companion', access: 'private', icon: '', title: 'همراه متخصص', menu: false, empty: true},
            {id: 10010, alias: 'account/tickets', path: 'tickets', access: 'private', icon: '', title: 'بلیط ها', menu: false},
            {id: 10011, alias: 'account/profile', path: 'profile', access: 'private', icon: '', title: 'پروفایل', menu: false},
        ]
    }
];

const getRoutes = async routes => {
    const routesTemp = [];

    const setRoute = async item => {

        const component = {data: null, name: null}

        const handleError = error => {

            console.log(error)
            //             localStorage.removeItem('auth')
            //             window.location.reload(false)

        }

        if(item.empty) {

            try {
                component.data = await import(`../public/page/Empty/Empty`)
                item['component'] = React.createElement(component.data.default);
            } catch (e) {
                handleError(e)
            }

        } else if (item.alias.includes('/')) {

            component.name = item.alias.split('/')
            component.name[0] = component.name[0].split('-').map((word) => word.charAt(0).toUpperCase() + word.substring(1)).join('')
            component.name[1] = component.name[1].split('-').map((word) => word.charAt(0).toUpperCase() + word.substring(1)).join('')
            if (component.name[2])
                component.name[2] = component.name[2].split('-').map((word) => word.charAt(0).toUpperCase() + word.substring(1)).join('')

            try {

                if (component.name[2])
                    component.data = await import(`../${item.access}/page/${component.name[0]}/${component.name[1]}/${component.name[2]}/${component.name[2]}`)
                else
                    component.data = await import(`../${item.access}/page/${component.name[0]}/${component.name[1]}/${component.name[1]}`)

                item['component'] = React.createElement(component.data.default);
            } catch (e) {
                handleError(e)
            }

        } else {

            component.name = item.alias.split('-').map((word) => word.charAt(0).toUpperCase() + word.substring(1)).join('')

            try {
                component.data = await import(`../${item.access}/page/${component.name}/${component.name}`)
                item['component'] = React.createElement(component.data.default);
            } catch (e) {
                handleError(e)
            }

        }

        return item;
    }

    for (const item of routes) {

        if (item.path) {

            const route = await setRoute(item)
            routesTemp.push(route)

        }

        if (item.children) {

            for (const child of item.children) {

                if (child.path) {

                    const route = await setRoute(child)
                    routesTemp.push(route)

                }

            }

        }

    }

    return routesTemp
}

export default getRoutes;